<div
  class="container container-cart site_b2c margencarro px-2"
  (window:resize)="onResize($event)"
>
  <app-guided-steps [step]="2" />

  <div class="row m-0">
    <!-- Start::formulario de registro de invitado -->
    @if(!isGuestRegistered && !isLoggedIn){
    <div class="col-12 lg:col-7 xl:col-8 py-0">
      <div class="card p-4">
        <div class="card-body">
          <app-login-register
            [innerWidth]="innerWidth"
            (outInvitado)="onGuestRegistered($event)"
            [invitado]="guest"
          />
        </div>
      </div>
      |
    </div>
    }
    <!-- End::formulario de registro de invitado -->

    <div
      class="col-12 py-0"
      *ngIf="
        (isGuestRegistered || isLoggedIn) &&
        shippingSelected &&
        HideResumen() &&
        select_grupos &&
        (recibeType == 'yo' || recibeType == 'otra')
      "
    >
      <div class="card" style="padding-bottom: 0px">
        <!-- Start::indica la tienda o dirección seleccionada -->
        <div
          class="card-header row align-items-center"
          style="margin-bottom: 0px !important; color: #0063b9 !important"
        >
          <div class="col-7">
            {{ tituloDespacho }}
          </div>
          <div class="col-5">
            <div
              class="btn btn-link float-end"
              style="color: #0063b9 !important"
              (click)="modificarSelectedAddress()"
              [attr.title]="
                (cart.shippingType$ | async) == 'despacho'
                  ? 'Cambiar dirección'
                  : 'Cambiar tienda'
              "
            >
              <i
                class="fa-solid fa-pen-to-square"
                style="margin-right: 10px"
              ></i
              >Cambiar
            </div>
          </div>
        </div>
        <!-- End::indica la tienda o dirección seleccionada -->
        <div
          class="card-body flex flex-wrap align-items-lg-center mt-2"
          style="margin-bottom: 10px"
        >
          <div class="col-12 sm:col-7 py-0">
            <p
              *ngIf="tienda && retiroFlag"
              class="subtitle"
              style="
                font-weight: normal;
                padding: 0.5rem 2px;
                margin-bottom: 0px;
                color: #0063b9 !important;
              "
            >
              {{ tienda.address }}
            </p>
            <p
              *ngIf="!retiroFlag && addressCustomerSelected"
              class="subtitle"
              style="
                font-weight: normal;
                padding: 0.5rem 2px;
                margin-bottom: 0px;
                color: #0063b9 !important;
              "
            >
              {{ addressCustomerSelected.address }}
            </p>

            @if(select_grupos){
            <p
              *ngFor="let item of fechas; let i = index"
              class="subtitle"
              style="
                font-weight: normal;
                padding: 0 2px;
                margin-bottom: 0px;
                font-size: 0.8rem;
                color: #0063b9 !important;
              "
            >
              <strong>Entrega {{ i + 1 }}/{{ fechas.length }}</strong>
              {{
                item ? (item | date : 'EEEE dd MMMM, y ') : ('' | titlecase)
              }}
            </p>
            }
          </div>
        </div>
      </div>
    </div>
    <div
      class="col-12 py-0"
      *ngIf="
        (isGuestRegistered || isLoggedIn) &&
        shippingSelected &&
        HideResumen() &&
        select_grupos &&
        tituloRecibe.length > 0
      "
    >
      <div class="card" style="margin-top: 5px; padding-bottom: 0px">
        <div class="card-header" style="margin-bottom: 0px !important">
          {{ tituloRecibe }}
        </div>
        <div class="card-body mt-2">
          <div class="col-12 lg:col-9 py-0" *ngIf="recibeOtraname.length > 0">
            {{ recibeOtraname | titlecase }}
          </div>
          <div
            class="col-12 lg:col-9 py-0"
            *ngIf="recibeOtraname.length === 0"
          >
            {{ recibeYoname | titlecase }}
          </div>
        </div>
      </div>
    </div>

    <!-- Start::tabs para seleccionar retiro o despacho -->
    <div
      class="lg:col-7 xl:col-8 xs:col-12 py-0"
      *ngIf="!select_grupos && (isGuestRegistered || isLoggedIn)"
    >
      <div class="card h-100 p-4">
        <div class="card-header" style="color: #0063b9; margin-left: 17px">
          ELIGE EL TIPO DE ENTREGA
        </div>
        <div class="card-body">
          <div name="detalleDespacho">
            <tabset [justified]="true" #tabsShipping>
              <!-- Start::tab retiro en tienda -->
              @if(isPickup){
              <tab
                [disabled]="loadingShipping"
                (selectTab)="onSelectShippingType('retiro')"
              >
                <ng-template tabHeading>
                  <i
                    class="fa-sharp fa-solid fa-store"
                    style="margin-right: 10px; font-size: 28px"
                  ></i>
                  <span class="title">Retirar en tienda</span>
                </ng-template>

                <div
                  class="mb-3 col-12 mt-3 py-0 px-3"
                  [hidden]="!stores.length"
                >
                  <ng-select
                    [clearable]="false"
                    [searchable]="true"
                    [items]="stores"
                    bindLabel="name"
                    bindValue="id"
                    class="form-control-select form-control-lg"
                    [(ngModel)]="selectedShippingIdStore"
                    placeholder="Seleccione una tienda"
                    [disabled]="isLoadingPickupDates"
                    #select
                    (change)="getPickup(); select.blur()"
                  >
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-index="index"
                    >
                      <p>
                        <b>{{ item.name }}</b>
                      </p>

                      <p style="margin-top: -10px">
                        <span class="text-justify">
                          <small>{{ item.address }}</small></span
                        >
                      </p>
                    </ng-template>
                  </ng-select>
                </div>
                <div
                  class="cart-address-container ml-3 col-12 p-1"
                  style="color: #0063b9; margin-bottom: 10px"
                  [ngStyle]="{ width: innerWidth > 450 ? '96%' : '92%' }"
                >
                  <div class="grid m-0">
                    <div
                      class="col-2 p-0 flex justify-content-center align-items-center"
                    >
                      <i
                        class="fa-solid fa-store m-0"
                        style="font-size: 21px !important; color: #0063b9"
                      ></i>
                    </div>
                    <div
                      *ngIf="tienda"
                      class="col-10 p-0"
                      style="font-size: 14px"
                    >
                      <div class="grid m-0">
                        <div class="col-6">
                          {{ tienda.address }}
                        </div>
                        <div
                          class="col-6"
                          style="font-weight: bold; font-size: 15px"
                        >
                          {{ pickupDescription | uppercase }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <app-loading-element
                  *ngIf="
                    isLoadingPickupDates ||
                    (!stores.length && !wereLoadedStores)
                  "
                  text="Cargando fechas"
                />
                <div *ngIf="!shippingDaysStore.length" class="no-shipping">
                  <div class="col-12 p-0">
                    <div
                      class="alert border border-warning"
                      style="width: 99%; color: #0063b9"
                    >
                      <h3 *ngIf="isLoggedIn">
                        Producto no disponible! . . .
                        <i class="fas fa-store-alt"></i
                        ><i
                          class="fas fa-exclamation-circle mt-2 float-end text-warning"
                        ></i>
                      </h3>
                      <p style="font-size: 12px">
                        Este producto no está disponible para la tienda
                        <strong>{{ tienda_actual.city }}</strong
                        >, seleccione otra tienda para continuar.
                      </p>
                    </div>
                  </div>
                </div>
                <!-- Detalle de productos con su fecha entrega -->
                <div class="col-12 py-0 px-3">
                  <ng-container
                    *ngFor="let item_0 of shippingDaysStore; let i = index"
                  >
                    <div
                      style="
                        border: 1px solid #0063b9;
                        border-radius: 5px;
                        border-top: none;
                      "
                    >
                      <app-grupo-detalle-productos
                        (eliminarGrupo)="eliminarGrupo($event)"
                        [index]="item_0.grupo"
                        [length]="shippingDaysStore.length"
                        [grupo_producto]="item_0.productodespacho"
                      />
                      <app-grupo-detalle-fechas
                        *ngIf="innerWidth > 1720"
                        [DIAS_SEMANA]="10"
                        (itemSeleccionado)="setSeleccionarEnvio($event, i)"
                        [index]="i"
                        [fletes]="item_0.fechas"
                      />

                      <app-grupo-detalle-fechas
                        *ngIf="innerWidth > 1420 && innerWidth <= 1720"
                        [DIAS_SEMANA]="8"
                        (itemSeleccionado)="setSeleccionarEnvio($event, i)"
                        [index]="i"
                        [fletes]="item_0.fechas"
                      />

                      <app-grupo-detalle-fechas
                        *ngIf="innerWidth > 450 && innerWidth <= 1420"
                        [DIAS_SEMANA]="7"
                        (itemSeleccionado)="setSeleccionarEnvio($event, i)"
                        [index]="i"
                        [fletes]="item_0.fechas"
                      />

                      <app-grupo-detalle-fechas-mobile
                        *ngIf="innerWidth <= 450"
                        (itemSeleccionado)="
                          setSeleccionarEnvioMobile($event, i)
                        "
                        [index]="i"
                        [fletes]="item_0.fechas"
                      />
                    </div>
                  </ng-container>
                </div>

                @if(shippingDaysStore.length){
                <div class="ms-2 mt-4">
                  <div class="mb-3 col-12 py-0" style="color: #0063b9">
                    <label>Seleccione quien retira el pedido</label>
                    <div class="clearfix"></div>

                    <div class="row ms-2 mt-3 mx-0">
                      <div class="col-sm p-0">
                        <div class="form-check form-check-lg">
                          <span class="form-check-input input-check">
                            <span class="input-check__body">
                              <input
                                (click)="setRecibe('yo')"
                                name="retiroYo"
                                class="input-check__input"
                                type="radio"
                                id="retiroYo"
                                [checked]="recibeType == 'yo'"
                              />
                              <span class="input-check__box"></span>
                              <app-icon
                                class="input-check__icon"
                                name="check-9x7"
                                size="19x19"
                              />
                            </span>
                          </span>
                          <label class="form-check-label" for="retiroYo"
                            >Yo retiro</label
                          >
                        </div>
                      </div>

                      <div class="col-sm p-0">
                        <div class="form-check form-check-lg">
                          <span class="form-check-input input-check">
                            <span class="input-check__body">
                              <input
                                (click)="setRecibe('otra')"
                                name="retiraOtro"
                                class="input-check__input"
                                type="radio"
                                id="retiraOtro"
                                [checked]="recibeType == 'otra'"
                              />
                              <span class="input-check__box"></span>
                              <app-icon
                                class="input-check__icon"
                                name="check-9x7"
                                size="19x19"
                              />
                            </span>
                          </span>
                          <label class="form-check-label" for="retiraOtro"
                            >Retira otra persona</label
                          >
                        </div>
                      </div>
                      <div
                        class="col-sm p-0"
                        (mousedown)="showMap = !showMap"
                        style="cursor: pointer"
                      >
                        <i
                          class="fa-solid fa-map-location-dot"
                          style="font-size: 28px; color: #0063b9"
                        ></i>
                        {{ showMap ? 'Ocultar Mapa' : 'Ver Mapa' }}
                      </div>
                    </div>
                  </div>

                  <div
                    class="row me-1"
                    *ngIf="recibeType == 'otra' && recibeOtraname.length > 0"
                  >
                    <div>
                      <p class="subtitle" style="color: #0063b9">
                        Persona que recibe
                      </p>
                    </div>
                    <div class="col-12 ms-1 py-0">
                      <div
                        class="cart-address-container pt-3 pb-3 ps-2"
                        [ngClass]="
                          HideResumen() ? '' : 'flex align-items-center'
                        "
                      >
                        <div class="row col-12 py-0">
                          <div class="col-12 sm:col-7">
                            {{ recibeOtraname | titlecase }}
                          </div>
                          <div class="col-12 sm:col-5 py-0">
                            <button
                              type="button"
                              class="btn btn-link text-start"
                              (click)="setRecibe('otra'); recibeOtraname = ''"
                              style="text-decoration: none; padding-left: 0px"
                            >
                              <i
                                class="fa-solid fa-pen-to-square"
                                style="
                                  font-size: 20px !important;
                                  margin-right: 10px;
                                "
                              ></i>
                              Cambiar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                }
                <div
                  class="row"
                  *ngIf="recibeType == 'otra' && !recibeOtraname.length"
                >
                  <div class="col-12 p-0">
                    <app-register-reception
                      (returnReceptionEvent)="reciboPedido($event)"
                    />
                  </div>
                </div>

                <div class="row">
                  <div
                    class="sm:col-12"
                    style="padding: 0 32px; margin-top: 10px"
                  >
                    @if(tienda && showMap){
                    <app-map
                      [autocompletado]="false"
                      [coordinates]="{ lat: tienda.lat, lng: tienda.lng }"
                    />
                    }
                  </div>
                </div>
                <br />
              </tab>
              }
              <!-- End::tab retiro en tienda -->

              <!-- Start::tab despacho a domicilio -->
              @if(isDelivery){
              <tab
                [disabled]="isLoadingPickupDates"
                (selectTab)="onSelectShippingType('despacho')"
              >
                <div [hidden]="showNewAddress">
                  <ng-template tabHeading>
                    <i
                      class="fas fa-truck"
                      style="margin-right: 10px; font-size: 28px"
                    ></i>
                    <span class="title hidden sm:inline"
                      >Despacho a domicilio</span
                    >
                    <span class="title sm:hidden">Despacho</span>
                  </ng-template>

                  <app-loading-element
                    *ngIf="loadingShippingAll"
                    text="Cargando direcciones"
                  />

                  <!-- Tarjeta de direcciones del usuario -->
                  <div
                    class="row mt-3"
                    *ngIf="isLoggedIn"
                    style="margin-left: 0px; margin-right: 0px"
                  >
                    <!-- Listado de direcciones de un usuario logeado -->

                    <div
                      *ngFor="let direccion of addresses"
                      class="col-12 py-0 px-3"
                    >
                      <div
                        class="cart-address-container"
                        *ngIf="
                          direccion.id === selectedShippingId || showAllAddress
                        "
                        [ngClass]="showAllAddress ? 'mb-4' : ''"
                      >
                        <div
                          class="row pb-2 pt-2 flex align-items-sm-center pl-2"
                        >
                          <div class="col-12 sm:col-6 py-0">
                            <i
                              class="fa-solid fa-location-dot fa-fw"
                              style="font-size: 20px"
                            ></i>
                            {{ direccion.fullAddress }}
                          </div>
                          <div
                            class="col-12 sm:col-6 py-0 flex flex-sm-row-reverse"
                            *ngIf="!showAllAddress"
                          >
                            <button
                              type="button"
                              (click)="viewAllAddress()"
                              class="btn btn-link"
                              style="
                                padding-left: 0px;
                                text-decoration: none;
                                color: #0063b9;
                              "
                            >
                              <i
                                class="fa-solid fa-pen-to-square fa-fw"
                                style="
                                  font-size: 20px !important;
                                  margin-right: 10px;
                                "
                              ></i>
                              Cambiar
                            </button>
                          </div>
                          <div
                            class="col-12 sm:col-6 py-0 flex flex-row-reverse"
                            *ngIf="showAllAddress"
                          >
                            <button
                              class="btn btn-sm btn-link text-red-500 p-0 flex"
                              style="align-items: center"
                              tooltip="Eliminar dirección"
                              placement="top"
                              container="body"
                              (click)="deleteDeliveryAddress(direccion)"
                            >
                              <i
                                class="fas fa-trash-alt text-red-500 fa-fw"
                                style="font-size: 16px !important"
                              ></i>
                            </button>
                            <button
                              type="button"
                              (click)="selectDeliveryAddress(direccion.id)"
                              style="text-decoration: none; color: #0063b9"
                              class="btn btn-link"
                            >
                              Usar Dirección
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 py-0 px-3">
                      <div
                        class="cart-new-address-container"
                        [ngClass]="showAllAddress ? 'mb-3' : ''"
                        *ngIf="showAllAddress || addresses.length === 0"
                      >
                        <div
                          class="row pb-2 pt-2 flex flex-wrap align-items-sm-center pl-2"
                        >
                          <div class="col-12 sm:col-6 py-0">
                            <i
                              class="fas fa-plus"
                              style="
                                font-size: 20px !important;
                                margin-right: 10px;
                              "
                            ></i>
                            Nueva Dirección
                          </div>
                          <div
                            class="col-12 sm:col-6 py-0 flex flex-row-reverse"
                          >
                            <button
                              name="open"
                              name="openModal"
                              title="Agregar Dirección"
                              data-bs-toggle="collapse"
                              (click)="showNewAddress = !showNewAddress"
                              data-target="#collapsenewAddress"
                              class="btn btn-link"
                              style="text-decoration: none; color: white"
                            >
                              Agregar dirección
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Listado de direcciones de un usuario logeado -->
                  </div>
                  <!-- END tarjeta de direcciones del usuario -->

                  <!-- Tarjeta de direcciones del invitado -->
                  <app-add-address
                    [invitado]="true"
                    *ngIf="isGuestRegistered && !showAddress"
                    (respuestaInvitado)="direccionVisita($event)"
                  />

                  <div *ngIf="isGuestRegistered && showAddress">
                    <div class="row ms-2 mt-3">
                      <div class="col-12 lg:col-6 py-0">
                        <p class="subtitle my-0 pt-0">Dirección de despacho</p>
                      </div>
                    </div>

                    <div class="col-12 ms-3 mt-3 py-0">
                      <div class="cart-address-container">
                        <div
                          class="row pb-3 pt-3 flex flex-wrap align-items-sm-center ps-2 me-1"
                        >
                          <div class="col-12 sm:col-7 py-0">
                            <div>
                              {{ usuarioInv.street }} {{ usuarioInv.number }},
                              depto/casa: {{ usuarioInv.department }},
                              {{ usuarioInv.commune }}
                            </div>
                            <!-- <div *ngIf="usuarioInv.depto.length <= 0"> {{usuarioInv.calle}} {{usuarioInv.numero}}, {{usuarioInv.comuna}} </div> -->
                          </div>
                          <div
                            class="col-12 sm:col-5 flex flex-sm-row-reverse py-0"
                          >
                            <button
                              title="Cambiar dirección"
                              (click)="removeAddressInvitado()"
                              class="btn btn-link text-center;"
                              style="text-decoration: none; padding-left: 0px"
                            >
                              Modificar
                              <div
                                class="me-1 hidetabletLandscape"
                                style="display: inline-block"
                              >
                                dirección
                                <i
                                  class="fas fa-pencil-alt ms-2 editIcon"
                                  style="font-size: 15px !important"
                                ></i>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- END tarjeta de direcciones del invitado -->

                  <div
                    class="container-shipping position-relative"
                    style="margin-left: 0px 10px"
                  >
                    <app-loading-element
                      *ngIf="
                        (loadingShipping && !isGuestRegistered) ||
                        (loadingShipping && showAddress && isGuestRegistered)
                      "
                      text="Cargando fechas"
                    />

                    <div *ngIf="!shippingDays.length" class="no-shipping">
                      <p
                        class="subtitle"
                        *ngIf="selectedShippingId == null && isLoggedIn"
                      >
                        Seleccione una dirección para proponer días de despacho
                      </p>

                      <div *ngIf="isLoggedIn" class="col-12 py-0">
                        <div
                          class="alert border border-warning"
                          style="width: 99%; color: #0063b9"
                        >
                          <h2 *ngIf="isLoggedIn">
                            Oops! . . .
                            <i class="fas fa-shipping-fast mt-2"></i
                            ><i
                              class="fas fa-exclamation-circle mt-2 float-end text-warning"
                            ></i>
                          </h2>
                          <p class="subtitle">
                            Este producto no está disponible para despacho a
                            domicilio, seleccione retiro en tienda para
                            continuar.
                          </p>
                          <!-- <p class="subtitle" *ngIf="(selectedShippingId!=null && !usuarioInvitado) || (usuarioInvitado && direccion && selectedShippingId!=null )">
                                                          No existe stock disponible para los productos seleccionados.</p> -->
                        </div>
                      </div>
                      <div *ngIf="!isLoggedIn && showAddress" class="col-12">
                        <div
                          class="alert border border-warning"
                          style="width: 99%"
                        >
                          <h2 *ngIf="isLoggedIn">
                            Oops! . . .
                            <i class="fas fa-shipping-fast mt-2"></i
                            ><i
                              class="fas fa-exclamation-circle mt-2 float-end text-warning"
                            ></i>
                          </h2>
                          <p class="subtitle">
                            Este producto no está disponible para despacho a
                            domicilio, seleccione retiro en tienda para
                            continuar.
                          </p>
                          <!-- <p class="subtitle" *ngIf="(selectedShippingId!=null && !usuarioInvitado) || (usuarioInvitado && direccion && selectedShippingId!=null )">
                                                          No existe stock disponible para los productos seleccionados.</p> -->
                        </div>
                      </div>
                    </div>

                    <!-- Días de despacho. tanto para invitados como logeados. -->
                    <div
                      *ngIf="
                        (isLoggedIn && selectedShippingId) ||
                        (isGuestRegistered && showAddress)
                      "
                    >
                      <!-- Segmento correspondiente al formulario asociado a la persona que recibe el producto-->
                      <div class="row ms-2 mt-3" *ngIf="shippingDays.length">
                        <!-- Formulario de  dias para despacho -->

                        <div class="row col-12 py-0">
                          <div class="col-12 py-0">
                            <ng-container
                              *ngFor="
                                let item_0 of shippingDays;
                                let i = index
                              "
                            >
                              <div
                                style="
                                  margin-bottom: 30px;
                                  border: solid 1px #0063b9;
                                  border-top: none;
                                  border-radius: 5px;
                                "
                              >
                                <app-grupo-detalle-productos
                                  (eliminarGrupo)="eliminarGrupo($event)"
                                  [index]="item_0.grupo"
                                  [length]="shippingDays.length"
                                  [grupo_producto]="item_0.productodespacho"
                                />

                                <app-grupo-detalle-fechas
                                  *ngIf="innerWidth > 1720"
                                  [DIAS_SEMANA]="10"
                                  (itemSeleccionado)="
                                    setSeleccionarEnvio($event, i)
                                  "
                                  [index]="i"
                                  [fletes]="item_0.fechas"
                                />
                                <app-grupo-detalle-fechas
                                  *ngIf="
                                    innerWidth > 1420 && innerWidth <= 1720
                                  "
                                  [DIAS_SEMANA]="8"
                                  (itemSeleccionado)="
                                    setSeleccionarEnvio($event, i)
                                  "
                                  [index]="i"
                                  [fletes]="item_0.fechas"
                                />
                                <app-grupo-detalle-fechas
                                  *ngIf="
                                    innerWidth > 450 && innerWidth <= 1420
                                  "
                                  [DIAS_SEMANA]="7"
                                  (itemSeleccionado)="
                                    setSeleccionarEnvio($event, i)
                                  "
                                  [index]="i"
                                  [fletes]="item_0.fechas"
                                />
                                <app-grupo-detalle-fechas-mobile
                                  *ngIf="innerWidth <= 450"
                                  (itemSeleccionado)="
                                    setSeleccionarEnvioMobile($event, i)
                                  "
                                  [index]="i"
                                  [fletes]="item_0.fechas"
                                />
                              </div>
                            </ng-container>
                          </div>
                        </div>
                        <!-- Fin Formulario de  dias para despacho -->

                        <div class="mb-3 col-12" style="color: #0063b9">
                          <div class="row ms-2 mt-3 mx-0">
                            <div class="col p-0">
                              <div class="form-check form-check-lg">
                                <span class="form-check-input input-check">
                                  <span class="input-check__body">
                                    <input
                                      (click)="setRecibe('yo')"
                                      name="tipoDocumento"
                                      class="input-check__input"
                                      type="radio"
                                      id="check-factura"
                                      [checked]="recibeType == 'yo'"
                                    />
                                    <span class="input-check__box"></span>
                                    <app-icon
                                      class="input-check__icon"
                                      name="check-9x7"
                                      size="19x19"
                                    />
                                  </span>
                                </span>
                                <label
                                  class="form-check-label"
                                  for="check-factura"
                                  >Yo recibo</label
                                >
                              </div>
                            </div>

                            <div class="col p-0">
                              <div class="form-check form-check-lg">
                                <span class="form-check-input input-check">
                                  <span class="input-check__body">
                                    <input
                                      (click)="setRecibe('otra')"
                                      name="tipoDocumento"
                                      class="input-check__input"
                                      type="radio"
                                      id="check-cotizacion"
                                      [checked]="recibeType == 'otra'"
                                    />
                                    <span class="input-check__box"></span>
                                    <app-icon
                                      class="input-check__icon"
                                      name="check-9x7"
                                      size="19x19"
                                    />
                                  </span>
                                </span>
                                <label
                                  class="form-check-label"
                                  for="check-cotizacion"
                                  >Recibe otra persona</label
                                >
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          class="row me-1"
                          *ngIf="
                            recibeType == 'otra' && recibeOtraname.length > 0
                          "
                        >
                          <div class="col-12">
                            <p
                              class="subtitle"
                              style="color: #0063b9 !important"
                            >
                              Persona que recibe
                            </p>
                          </div>
                          <div class="col-12 ms-1">
                            <div
                              class="cart-address-container pt-3 pb-3 ps-2"
                              [ngClass]="
                                HideResumen() ? '' : 'flex align-items-center'
                              "
                            >
                              <div class="row col-12">
                                <div class="col-12 sm:col-7">
                                  {{ recibeOtraname | titlecase }}
                                </div>
                                <div class="col-12 sm:col-5">
                                  <button
                                    type="button"
                                    class="btn btn-link text-start"
                                    (click)="
                                      setRecibe('otra'); recibeOtraname = ''
                                    "
                                    style="
                                      text-decoration: none;
                                      padding-left: 0px;
                                      color: #0063b9;
                                    "
                                  >
                                    Cambiar
                                    <div
                                      class="hidetabletLandscape"
                                      style="display: inline-block"
                                    >
                                      datos
                                      <i
                                        class="fas fa-pencil-alt ms-2"
                                        style="font-size: 15px !important"
                                      ></i>
                                    </div>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="row"
                        *ngIf="
                          recibeType == 'otra' && recibeOtraname.length == 0
                        "
                      >
                        <div class="sm:col-12">
                          <app-register-reception
                            (returnReceptionEvent)="reciboPedido($event)"
                          />
                        </div>
                      </div>
                      <!-- Fin Segmento correspondiente al formulario asociado a la persona que recibe el producto-->
                    </div>
                  </div>
                </div>
                <!-- Start::agregar dirección -->
                <div class="row" *ngIf="showNewAddress">
                  <div class="col-12" id="collapsenewAddress">
                    <app-add-address
                      [invitado]="false"
                      (respuesta)="respuesta($event)"
                    />
                  </div>
                </div>
                <!-- End::agregar dirección -->
              </tab>
              }
              <!-- End::tab despacho a domicilio -->
            </tabset>
          </div>
        </div>
      </div>
    </div>
    <!-- End::tabs para seleccionar retiro o despacho -->

    <!-- Start::Resumen de compra (escritorio) -->
    @if(innerWidth >= 992){
    <div
      class="col-12 lg:col-5 xl:col-4"
      [hidden]="showAllAddress ? true : false"
      style="padding: 15px; background-color: #e3e3e3"
    >
      <div class="card h-100">
        <div class="card-header" style="margin-bottom: 1px !important">
          <div
            class="mostrarResumen"
            (click)="showDetalleProductos = !showDetalleProductos"
          >
            <div class="ms-1" style="display: inline-block; color: #0063b9">
              Resumen de tu compra
            </div>
            <div
              *ngIf="!shippingSelected && HideResumen()"
              style="display: inline-block"
              class="float-end"
            >
              <div style="float: right">
                <i
                  [class]="
                    showDetalleProductos
                      ? 'fas fa-chevron-down'
                      : 'fas fa-chevron-up'
                  "
                ></i>
              </div>
            </div>
          </div>
        </div>
        <hr class="my-2" />

        <div
          class="card-body"
          [hidden]="valshowDetalleProductos() ? false : true"
        >
          <app-loading-element
            *ngIf="loadingResumen"
            text="Actualizando total"
          />

          <app-detalle-carro-productos
            *ngIf="!loadingResumen"
            [shippingType]="shippingType"
            [shoppingCartProducts]="productCart"
          />

          <!-- Start::botones de acción -->
          <div class="flex">
            <div class="mt-1 col-6 py-0 px-1">
              <a
                [routerLink]="['/', 'carro-compra']"
                (click)="removeDespacho()"
                class="btn text-sm btn-border-primary w-100 btn-lg text-center"
              >
                <i class="fas fa-chevron-left"></i> Anterior
              </a>
            </div>

            <div class="mt-1 col-6 py-0 px-1">
              <button
                name="next"
                *ngIf="
                  session.userRole != 'comprador' &&
                  session.userRole != 'buyer'
                "
                [disabled]="
                  !shippingSelected ||
                  !cartSession.shipment?.addressId ||
                  !productsValidate.length ||
                  recibeOtra
                "
                (click)="goToPaymentPage()"
                class="btn text-sm btn-lg btn-secondary w-100 text-center"
              >
                Ir a pagar <i class="fas fa-chevron-right"></i>
              </button>

              <button
                name="selectedShippingId"
                *ngIf="
                  session.userRole == 'comprador' ||
                  session.userRole == 'buyer'
                "
                [disabled]="shippingSelected == null"
                (click)="goToPaymentPage()"
                class="btn btn-lg text-sm btn-secondary w-100 text-center"
              >
                Siguiente <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
          <!-- End::botones de acción -->

          <div
            class="row text-primary mt-3"
            *ngIf="
              documentType != 'cotizacion' &&
              session.userRole !== 'compradorb2c' &&
              session.userRole !== 'b2c' &&
              session.userRole !== 'temp'
            "
          >
            <div class="col-12 text-end">
              <div
                class="cotizacionBtn"
                (click)="documentType = 'cotizacion'"
                style="color: #0063b9 !important"
              >
                Obtener cotización <i class="fas fa-file-invoice-dollar"></i>
              </div>
            </div>
          </div>
          <ng-container *ngIf="documentType == 'cotizacion'">
            <div class="w-100 text-center mt-4">
              <i class="far fa-file-pdf text-blue"></i>
              <p class="text-center subtitle w-100 text-blue">
                Ha elegido generar una cotización, presione el boton continuar
                si esta seguro.
              </p>
              <button
                type="button"
                name="finishQuotation"
                class="btn btn-outline-primary me-3"
                (click)="generateQuotation()"
              >
                Confirmar
              </button>
              <button
                type="button"
                name="cancelarQuotation"
                class="btn btn-outline-warning"
                (click)="documentType = 'factura'"
              >
                Cancelar
              </button>
            </div>
          </ng-container>
          <app-loading-element
            *ngIf="loadingCotizacion"
            text="Generando cotización..."
          />
        </div>
      </div>
    </div>
    }
    <!-- End::Resumen de compra (escritorio) -->

    <!-- Start::Resumen de compra (tablet) -->
    @if(innerWidth >= 450 && innerWidth < 992){
    <div
      class="col-12 lg:col-5 xl:col-4"
      style="
        margin-top: 10px;
        margin-bottom: 10px;
        padding: 15px;
        background-color: #e3e3e3;
      "
      [hidden]="showAllAddress ? true : false"
    >
      <div class="card h-100">
        <div class="card-header" style="margin-bottom: 1px !important">
          <div
            class="mostrarResumen"
            (click)="showDetalleProductos = !showDetalleProductos"
          >
            <div class="ms-1" style="display: inline-block">
              Resumen de tu compra
            </div>
          </div>
          <hr class="my-2" />
        </div>
        <div class="card-body">
          <app-loading-element
            *ngIf="loadingResumen && innerWidth > 700"
            text="Actualizando total"
          />

          <app-detalle-carro-productos
            [shippingType]="shippingType"
            [shoppingCartProducts]="productCart"
          />

          <!-- Start::botones de acción -->
          <div class="flex">
            <div class="mt-1 col-6 py-0 px-1">
              <a
                [routerLink]="['/', 'carro-compra']"
                (click)="removeDespacho()"
                class="btn btn-border-primary text-sm w-100 btn-lg text-center"
              >
                <i class="fas fa-chevron-left"></i> Anterior
              </a>
            </div>

            <div class="mt-1 col-6 py-0 px-1">
              <button
                name="next"
                *ngIf="
                  session.userRole != 'comprador' &&
                  session.userRole != 'buyer'
                "
                [disabled]="
                  shippingSelected == null ||
                  !cartSession.shipment?.addressId ||
                  !productsValidate.length ||
                  recibeOtra
                "
                (click)="goToPaymentPage()"
                class="btn btn-lg text-sm btn-secondary w-100 text-center"
              >
                Ir a pagar <i class="fas fa-chevron-right"></i>
              </button>

              <button
                name="selectedShippingId"
                *ngIf="
                  session.userRole == 'comprador' ||
                  session.userRole == 'buyer'
                "
                [disabled]="shippingSelected == null"
                (click)="goToPaymentPage()"
                class="btn btn-lg text-sm btn-secondary w-100 text-center"
              >
                Siguiente <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
          <!-- End::botones de acción -->
        </div>
      </div>
    </div>
    <!-- End::Resumen de compra (tablet) -->
    }
  </div>
</div>

<!-- Start::resumen de compra mobile??? -->
<ng-container *ngIf="(isGuestRegistered || isLoggedIn) && innerWidth < 450">
  <div
    *ngIf="!shippingSelected"
    [ngStyle]="{
      'margin-bottom': showDetalleProductos == true ? '265px' : '195px'
    }"
  ></div>
  <div
    *ngIf="shippingSelected && !select_grupos"
    [ngStyle]="{
      'margin-bottom': showDetalleProductos == true ? '265px' : '195px'
    }"
  ></div>
  <div
    *ngIf="shippingSelected && select_grupos"
    class="ms-3 me-3"
    style="margin-top: 5px"
    [ngStyle]="{
      'margin-bottom': showDetalleProductos == true ? '265px' : '195px'
    }"
    [hidden]="showAllAddress ? true : false"
  >
    <div class="card" [ngClass]="valshowDetalleProductos() ? 'h-100' : ''">
      <div class="card-header" style="margin-bottom: 1px !important">
        <div (click)="showDetalleProductos = !showDetalleProductos">
          <div class="ms-1 text-justify" style="color: #0063b9">
            <strong> Resumen de tu compra ({{ items.length }})</strong>
          </div>
        </div>
        <hr class="my-2" />
      </div>
      <div class="card-body text-justify">
        <app-loading-element
          *ngIf="loadingResumen && innerWidth > 700"
          text="Actualizando total"
        />
        <app-detalle-carro-productos
          [shippingType]="shippingType"
          [seePrices]="false"
          [shoppingCartProducts]="productCart"
        />
      </div>
    </div>
  </div>

  <div class="footer-page w-screen sticky" style="z-index: 900">
    <div
      style="margin-top: 5px; margin-bottom: -13px"
      [hidden]="showAllAddress ? true : false"
    >
      <div class="card" [ngClass]="valshowDetalleProductos() ? 'h-100' : ''">
        <div class="card-header" style="margin-bottom: 1px !important">
          <div
            class="row flex"
            (click)="showDetalleProductos = !showDetalleProductos"
          >
            <div
              class="col-9 text-justify"
              style="font-size: 16px; margin-bottom: -20px; color: #0063b9"
            >
              <strong>Resumen de tu Compra ({{ items.length }})</strong>
            </div>
            <div *ngIf="HideResumen()" class="col-3 text-end">
              <i
                [class]="
                  showDetalleProductos
                    ? 'fas fa-chevron-down'
                    : 'fas fa-chevron-up'
                "
              ></i>
            </div>
          </div>
        </div>
        <div
          class="card-body text-justify"
          style="font-size: 14px"
          *ngIf="showDetalleProductos"
        >
          <app-loading-element
            *ngIf="loadingResumen && innerWidth > 700"
            text="Actualizando total"
          />

          <app-detalle-carro-productos
            [shippingType]="shippingType"
            [seeProducts]="false"
            [shoppingCartProducts]="productCart"
          />
        </div>
        <!-- <div class="card-body" *ngIf="!showDetalleProductos">
                    <app-loading-element *ngIf="loadingResumen && innerWidth > 700" text="Actualizando total"/>
                    <app-detalle-carro-productos [shippingType] = 'shippingType' [seeProducts]="false" [show]="false" [productCart]="productCart"/>
                </div> -->
        <div *ngIf="!showDetalleProductos" class="card-body text-justify">
          <div class="dropcart__totals text-justify">
            <table>
              <tr style="font-size: 14px; color: #0063b9">
                <th>Total</th>
                <td class="fw-bold">
                  {{ cart.total$ | async | currency }}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="row m-0">
          <!-- <div class="mt-3 col-6 ps-0 ps-1" >
                <a [routerLink]="['/','carro-compra']" (click)="removeDespacho()" class="btn btn-border-primary w-100 btn-lg text-center" style="background-color:white;">
                    <i class="fas fa-chevron-left"></i> Anterior
                </a>
            </div> -->

          <!-- Start::botones de acción -->
          <div class="mt-1 col-12 py-0 px-1">
            <button
              name="next"
              *ngIf="
                session.userRole != 'comprador' && session.userRole != 'buyer'
              "
              [disabled]="
                shippingSelected == null ||
                !cartSession.shipment?.addressId ||
                !productsValidate.length ||
                recibeOtra ||
                !select_grupos
              "
              (click)="goToPaymentPage()"
              class="btn btn-lg text-sm btn-secondary w-100 text-center"
            >
              Ir a pagar <i class="fas fa-chevron-right"></i>
            </button>

            <button
              name="selectedShippingId"
              *ngIf="
                session.userRole == 'comprador' || session.userRole == 'buyer'
              "
              [disabled]="shippingSelected == null"
              (click)="goToPaymentPage()"
              class="btn btn-lg text-sm btn-secondary w-100 text-center"
            >
              Siguiente <i class="fas fa-chevron-right"></i>
            </button>
          </div>
          <!-- End::botones de acción -->

          <div class="mt-1 col-12 py-0 px-1">
            <a
              [href]="config.fullUrl"
              style="color: #118565; text-align: center; font-weight: bold"
            >
              Seguir comprando</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
